var buttons = document.querySelectorAll(".cta-link--request");
var modalOverlay = document.querySelector(".modalOverlay");
var modalContainer = document.querySelector(".modalContainer");
var body = document.body;
var modal = document.querySelector(".messageWrapper");
var lastButton;
var closeModal = document.getElementById('brochure-form-close');

TweenMax.set([modalOverlay, modal], { autoAlpha: 0 });

for (var i = 0; i < buttons.length; i++) {
  buttons[i].addEventListener("click", popUp);
}

function popUp() {
  
  var newRect = getPosition(modal, this);
  lastButton = this;

  TweenMax.set(modal, {
    x: newRect.left,
    y: newRect.top,
    width: newRect.width,
    height: newRect.height
  });

  var show = new TimelineMax();

  show.to(modalOverlay, 0.5, { autoAlpha: 0.75 });
  show.to(modal, 0.5, {
    x: 0,
    y: 0,
    width: 1040,
    height: 850,
    autoAlpha: 1
  });
  body.classList.add("no-scroll");
  modalContainer.classList.add('open');
}

if (modalOverlay) {
  modalOverlay.addEventListener("click", function() {
    var newRect = getPosition(modal, lastButton);
    var hide = new TimelineMax();

    TweenMax.killTweensOf(".messageWrapper");

    hide.to(modal, 0.5, {
      autoAlpha: 0,
      x: newRect.left,
      y: newRect.top,
      height: newRect.height,
      width: newRect.width
    });
    hide.to(".modalOverlay", 0.5, { autoAlpha: 0 });
    modalContainer.classList.remove('open');

    body.classList.remove("no-scroll");
  });
}

if (closeModal) {
  closeModal.addEventListener("click", function() {
    event.preventDefault;
    var newRect = getPosition(modal, lastButton);
    var hide = new TimelineMax();

    TweenMax.killTweensOf(".messageWrapper");

    hide.to(modal, 0.5, {
      autoAlpha: 0,
      x: newRect.left,
      y: newRect.top,
      height: newRect.height,
      width: newRect.width
    });
    hide.to(".modalOverlay", 0.5, { autoAlpha: 0 });
    modalContainer.classList.remove('open');

    body.classList.remove("no-scroll");
  });
}

function getPosition(elem, target) {
  var targetRect = target.getBoundingClientRect();
  var elemRect = elem.getBoundingClientRect();

  TweenLite.set(elem, {
    x: 0,
    y: 0,
    width: targetRect.width,
    height: targetRect.height
  });
  var newRect = elem.getBoundingClientRect();
  TweenLite.set(elem, { width: elemRect.width, height: elemRect.height });
  return {
    left: targetRect.left - newRect.left,
    top: targetRect.top - newRect.top,
    width: newRect.width,
    height: newRect.height
  };
}
